import jwtDecode from 'jwt-decode';
import http from './httpService';
import { appDataStore } from '../constants';

const tokenKey = 'token';

http.setJwt(getJwt());

export async function login(email, password) {
  //const { data: jwt } = await http.post(appDataStore.apiConfig.SignIn, { email, password });
  const { data } = await http.post(appDataStore.apiConfig.AuthLogin.url, { email: email, password: password });
  console.log('login response', data);
  localStorage.setItem(tokenKey, data.accessToken);
}

export function loginWithJwt(jwt) {
  localStorage.setItem(tokenKey, jwt);
}

export function logout() {
  localStorage.removeItem(tokenKey);
}

export function getCurrentUser() {
  try {
    const jwt = localStorage.getItem(tokenKey);
    return jwtDecode(jwt);
  } catch (ex) {
    return null;
  }
}

export function getJwt() {
  return localStorage.getItem(tokenKey);
}

export default {
  login,
  loginWithJwt,
  logout,
  getCurrentUser,
  getJwt,
};
